import { KLoggingEventBuilder2t27iqox7tpd3 as KLoggingEventBuilder } from '../KLoggingEventBuilder.mjs';
import { KotlinLoggingConfiguration_getInstance1qkm2mkxywgav as KotlinLoggingConfiguration_getInstance } from '../KotlinLoggingConfiguration.mjs';
import { KLoggingEvent3el01063mcenm as KLoggingEvent } from '../KLoggingEvent.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  info3uezdutu3rpr2 as info,
  info2hxv79dt541ps as info_0,
  info2wxw456lwpd2r as info_1,
  error12wpw0xi3o0bs as error,
  error1aa4zvb3h0fa3 as error_0,
  KLogger368y32iihya1v as KLogger,
} from '../KLogger.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var KLoggerDirectClass;
function KLoggerDirect() {
  if (KLoggerDirectClass === VOID) {
    class $ {
      constructor(name) {
        this.e2h_1 = name;
      }
      t2g(level, marker, block) {
        if (this.g2h(level, marker)) {
          // Inline function 'kotlin.apply' call
          var this_0 = new (KLoggingEventBuilder())();
          block(this_0);
          // Inline function 'kotlin.run' call
          if (level.w1_1 !== 5) {
            KotlinLoggingConfiguration_getInstance().x2f_1.f2h().v2f(KLoggingEvent().x2g(level, marker, this.e2h_1, this_0));
          }
        }
      }
      g2h(level, marker) {
        return level.c2h();
      }
    }
    protoOf($).l2g = info;
    protoOf($).n2g = info_0;
    protoOf($).m2g = info_1;
    protoOf($).u2g = error;
    protoOf($).v2g = error_0;
    initMetadataForClass($, 'KLoggerDirect', VOID, VOID, [KLogger()]);
    KLoggerDirectClass = $;
  }
  return KLoggerDirectClass;
}
//region block: exports
export {
  KLoggerDirect as KLoggerDirect1gyffbbrrlqc0,
};
//endregion

//# sourceMappingURL=KLoggerDirect.mjs.map
